var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.5 0L5.442 1.058 9.627 5.25H.5v1.5h9.127l-4.185 4.193L6.5 12l6-6-6-6z","fill":"#000"}));
}

ArrowRight.defaultProps = {"width":"13","height":"12","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
